import React from 'react';
import styled from '@emotion/styled';
import mq from "../../Styles/breakpoints";
import Overlay from "./Overlay";
import { css } from '@emotion/core';
import { PrimaryAlternateLink } from "../../Core/components/Buttons";
import { asset } from './helpers';
import padding from "../../Styles/padding";
import colors from "../../Styles/colors";

const flexItems = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: ${padding.large};
`;

const exampleLine = css`
  background-image: url('/content/themes/tpt/dist/images/passport/line.png');
  background-size: 50% 39px;
  background-repeat: no-repeat;
  background-position: 0px 10px;
`;

const PassportBlockWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    background-color: #f2f2f2;
    overflow: hidden;
  `;

const PassportCallout = styled.div`
    position: relative; 
    width: 40%; 
    display: flex; 
    align-items: center; 
    justify-content: center;
  `;

const PassportInformation = styled.div`
    position: relative; 
    padding: 2.75em;
    width: 100%; 

    ${mq.large(`
      width: 60%;
    `)};
  `;

const PassportExample = styled.div`
    display: flex; 
    justify-content: center; 
    align-items: center; 
    margin-bottom: 32px;
    
    ${mq.large(`
      font-size: 1.3em;
    `)};
  `;

const posters = css`
    display: none;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    height: 100%;

    & img {
      width: 100%;
    }
  
    ${mq.large(`
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 1;
      display: grid;
      display: ms-grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
    `)}

    ${mq.xxlarge(`
      grid-template-columns: 1fr 1fr 1fr; 
      grid-template-rows: auto auto 1fr;
    `)}
  `;

const outlineLink = css`
    background: transparent !important;
    color: #222222 !important;
    border-color: #222 !important;
    
    &:hover {
      color: ${colors.accent} !important;
      border-color: ${colors.accent} !important;
    }
  `;

const showForWideDown = css`
  @media (min-width: 899px) {
    display: none !important;
  }
`;

const hideForWideDown = css`
  @media (max-width: 900px) {
    display: none !important; 
    padding: 0;
  }
`;

const PassportBlock = (props) => {


  return (
    <PassportBlockWrapper>
      <PassportCallout className="show-for-large-up">
        <h2 css={css`position: relative; z-index: 2; color: #fff; text-align: center;`}>Watch Even More With <br />
          <img css={css`height: 1em; margin: -5px 0px 0px 0px;`} src="/content/themes/tpt/dist/images/passport-rose.svg" alt="TPT Passport Logo" /> <em css={css`font-weight: bolder; font-style: normal;`}>TPT</em> | Passport
        </h2>
        <div css={posters}>
          <Overlay opacity="0.7" />
          <img src={asset("passport/07.jpg")} alt="Victoria" />
          <img src={asset("passport/01.jpg")} alt="American Experience" />
          <img src={asset("passport/03.jpg")} alt="Nature" />
          <img src={asset("passport/05.jpg")} alt="Great British Baking Show" />
          <img src={asset("passport/06.jpg")} alt="Nova" />
          <img src={asset("passport/12.jpg")} alt="Austin City Limits" />
        </div>
      </PassportCallout>

      <PassportInformation>
        <h2 css={css`text-align: center;`}>Qualifying TPT members can binge full seasons of their favorite shows</h2>
        <PassportExample>
          <div className="row">
            <div css={showForWideDown}>
              <div css={[flexItems, { justifyContent: 'flex-start' }]} >
                <h3>Look for this symbol</h3>
                <img css={css`margin-bottom:${padding.large};width:100%;`} src="/content/themes/tpt/dist/images/passport/example-vert.png" className="" alt="passport icon example" />
                <p>TPT Passport content is identified by this distinctive icon.</p>
              </div>
            </div>

            <div css={hideForWideDown}>
              <div css={[flexItems, { justifyContent: 'flex-start' }]} className="small-12 large-6 xlarge-6 columns" >
                <h3>Look for this symbol</h3>
                <p>TPT Passport content is identified by this distinctive icon.</p>
              </div>
              <div css={[flexItems, exampleLine, { justifyContent: 'flex-start', alignItems: 'center' }]} className="small-12 large-6 xlarge-6 columns" >
                <img src={asset("passport/passport-icon-image.jpg")} alt="Passport logo in corner of television screen" />
              </div>
            </div>

          </div>
        </PassportExample>

        <div css={css`clear: both; text-align: center;`}>
          <PrimaryAlternateLink css={outlineLink} href="/passport">More about Passport</PrimaryAlternateLink>
        </div>
      </PassportInformation>
    </PassportBlockWrapper>
  );
}

export default PassportBlock;